<template>
  <div
    id="players-round-table"
    :class="`content-wrapper animation-slide h-auto `"
  >
    <RoundFinder
      :fieldToExclude="fieldToExclude"
      :customFilters="computedFilters"
      :customColumns="computedColumns"
      :endpointProps="isLiveCasino ? 'spins/roulette/' : ''"
      :modalComponent="isLiveCasino ? LiveCasinoRoundModal : null"
      :skinIdProps="effectiveSkinId"
      :playerIdProps="player_id"
    />
  </div>
</template>

<script>
import Filters from "../table/Filters.vue";
import Table from "../table/Table.vue";
import { mapGetters } from "vuex";

import RoundFinder from "../round/RoundFinder.vue";
import LiveCasinoRoundModal from "@/livecasino/components/LiveCasinoRoundModal.vue";

export default {
  name: "PlayerRounds",
  components: {
    Filters,
    Table,
    RoundFinder,
    LiveCasinoRoundModal,
  },
  props: {
    player_id: String,
    category: {
      type: String,
      default: "slot",
    },
  },
  watch: {},
  data() {
    return {
      LiveCasinoRoundModal,
      currentPage: 1,
      totalPages: 1,
      round_id: "",
      type_id: "All",
      bet_id: "",
      freebet_id: "",
      start_date: null,
      end_date: null,
      tableData: [],
      isLoading: false,
      is_native_currencies: true,
      showDetailModal: false,
      fullInfo: false,
      roundInfo: [],
      totalElements: 0,
      skinFilt: "",
      limit: [
        { label: "15", value: 15, selected: true },
        { label: "25", value: 25, selected: false },
        { label: "50", value: 50, selected: false },
        { label: "100", value: 100, selected: false },
      ],
      selectedLimit: 15,
      base_columns: [
        {
          slug: "roundId",
          type: "text",
          button: false,
        },
        {
          slug: "multiplier",
          type: "number",
          button: false,
          isMultiplierField: true,
        },
        {
          slug: "created_at",
          label: "Start Time",
          type: "date",
          button: false,
        },
        {
          slug: "updated_at",
          label: "End Time",
          type: "date",
          button: false,
        },
      ],
      player_column: [
        {
          slug: "user_id",
          type: "text",
          label: "Player ID",
          button: false,
        },
      ],
      advanced_column: [
        {
          slug: "uuid",
          label: "Bet ID",
          type: "text",
          button: false,
        },
        {
          slug: "amount",
          type: "number",
          button: false,
        },
        {
          slug: "type_id",
          label: "Bet Type",
          type: "text",
        },
        {
          slug: "win",
          type: "number",
          button: false,
        },
        {
          slug: "cashedOut",
          label: "Cashed Out",
          type: "number",
          button: false,
        },
        {
          slug: "autocashout",
          type: "text",
          button: false,
        },
        {
          slug: "cashout_time",
          label: "Cashout Time",
          type: "date",
          button: false,
        },
      ],
      action_column: [
        {
          type: "action_button",
          label: "Detail",
          button: true,
          buttonType: {
            icon: "eye",
            action: "openRoundDetail",
          },
        },
      ],
      columns: [],
      filters: [
        {
          label: "Round ID",
          type: "text",
          placeholder: "Search for Round ID",
          property: "round_id",
        },
        {
          label: "Player ID",
          type: "text",
          placeholder: "Search for Player ID",
          property: "player_id",
          disabled: true,
          default: this.player_id,
        },
        {
          label: "Bet Type",
          type: "select",
          placeholder: "Choose Bet Type",
          property: "type_id",
          options: ["All", "Cashout 1", "Cashout 2", "Even/Odd", "Ranges"],
        },
        {
          label: "Bet ID",
          type: "text",
          placeholder: "Search for Bet ID",
          property: "bet_id",
        },
        {
          label: "Start Date",
          type: "datetime-local",
          placeholder: "Start Date",
          property: "start_date",
          isDateTime: true,
        },
        {
          label: "End Date",
          type: "datetime-local",
          placeholder: "End Date",
          property: "end_date",
          isDateTime: true,
        },
        {
          label: "Freebet ID",
          type: "text",
          placeholder: "Search for Freebet ID",
          property: "freebet_id",
        },
      ],
      modalTitle: "",
      modalData: [],
      modalFullDetail: [],
      fieldToExclude: ["player_id"],
    };
  },
  computed: {
    ...mapGetters(["allowedSkins", "isAdmin", "isMenuOpen", "chatSkinFilter"]),
    isLiveCasino() {
      if (this.category) {
        return this.category.toLowerCase() === "livecasino";
      }
      return (
        this.$route?.meta?.section === "livecasino" ||
        this.$route?.path?.includes("/livecasino")
      );
    },
    effectiveSkinId() {
      if (!this.player_id) return null;
      const parts = this.player_id.split("_");
      return parts.length > 0 && !isNaN(parseInt(parts[0]))
        ? parseInt(parts[0])
        : null;
    },
    computedFilters() {
      return this.filters
        .filter((filter) => {
          // If in Live Casino category, remove Bet Type filter
          if (
            this.isLiveCasino &&
            (filter.property === "type_id" || filter.label === "Bet Type")
          ) {
            return false;
          }
          return true;
        })
        .map((filter) => {
          if (filter.property === "player_id") {
            return {
              ...filter,
              default: this.player_id,
              disabled: true,
            };
          }
          return filter;
        });
    },
    computedColumns() {
      if (this.isLiveCasino) {
        return [
          { slug: "uuid", label: "Bet ID", type: "text" },
          { slug: "roundId", label: "Round ID", type: "text" },
          { slug: "game_id", label: "Game ID", type: "text" },
          {
            slug: "multiplier",
            label: "Extracted Number",
            type: "chip",
            isMultiplierField: false,
          },
          { slug: "amount", label: "Amount", type: "number" },
          { slug: "win", label: "Win", type: "number" },
          { slug: "table", label: "Table", type: "text" },
          { slug: "type", label: "Bet Count", type: "text" },
          { slug: "created_at", label: "Start Time", type: "date" },
          {
            type: "action_button",
            label: "Detail",
            button: true,
            slug: "actions",
          },
        ];
      }
      return null;
    },
  },
  async created() {},
  async mounted() {},
  beforeUnmount() {},
  methods: {},
};
</script>
